
<template>
  <div class="middle-box text-center loginscreen  animated fadeInDown">
      <h3>上传一个文件到Oss存储</h3>
      <el-upload
          class="upload-demo"
          drag
          list-type="picture"
          action="https://api.jingshijue.cn/ossupload/uploadoss"
          :data="{'bucketname':'newkaisuopath','bucketpath':'testpath'}"
          :on-success="OnSuccess"
          :on-error="OnError"
          :before-upload="BeforeUpload"
          multiple>
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">可上传图片，且不超过2MB</div>
      </el-upload>
      <p class="text-muted text-center"><small class="morenzhifont" v-on:click="ReSetParams">已上传，继续解析数据</small>
      </p>
  </div>

</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import { Message } from 'element-ui'
import ElInput from '../../../node_modules/element-ui/packages/input/src/input'

Vue.prototype.$http = axios
var that = this
export default {
  components: {ElInput},
  name: 'UpLoadMore',
  beforeCreate: function () {
    console.log('开始创建')
    that = this
    that.$http({
      url: 'http://localhost:8009/createbucketpath',
      method: 'post',
      data: {
        bucketname: 'newkaisuopath3',
        bucketpath: 'test1'
      }
    })
      .then(function (res) {
        console.log(res)
      })
      .catch(function (error) {
        console.log('error' + error)
      })
  },
  methods: {
    ReSetParams: function () {
    },
    OnError (res) {
      console.log(res)
    },
    OnSuccess (res, file, fileList) {
      console.log(res)
      console.log(file)
      console.log(fileList)
      Message.success('上传成功，已上传至OSS存储')
    },
    BeforeUpload (file) {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  input[type="file"] {
    display: none;
  }
  .middle-box {
    width: 600px;
    max-width: 800px;
  }
  .morenzhifont
  {
    font-size:13px;
    color: #23527C;
    cursor: pointer;
  }
  .upload-demo
  {
    width: 400px;
    margin-left:auto;
    margin-right:auto;
  }

</style>



// WEBPACK FOOTER //
// src/views/uploadfile/UpLoadKSOss.vue